"use strict";

import "angular";
import "angular-resource";
import "angular-translate";

//Directive
import AccuCodeService from "../layout/service/AccuCodeService";

import PersonalMessagingController from "./PersonalMessagingController";
import PersonalMessagingDirective from "./PersonalMessagingDirective";
import PersonalMessagingFactory from "./PersonalMessagingFactory.js";
import PersonalMessagingService from "./PersonalMessagingService";

const PersonalMessagingModule = angular
    .module("PersonalMessagingModule", ["ngResource"])
    .controller("personalMessagingController", PersonalMessagingController)
    .service("personalMessagingService", PersonalMessagingService)
    .service("AccuCodeService", AccuCodeService)
    .factory("personalMessagingFactory", PersonalMessagingFactory)
    .directive("personalMessaging", PersonalMessagingDirective);

export default PersonalMessagingModule;
